var exports = {
  "D": "xe7b6e3d6--ee24d4--title",
};

module.exports = exports;
